var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeclineCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 27,
    viewBox: "0 0 27 27",
    width: 27,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.17529333 22.87768-.84196 3.7889867 3.78898667-.84196c5.1041742 3.5759778 12.0950315 2.6570137 16.1016334-2.1165963s3.6995038-11.8179178-.7073211-16.22474274c-4.4068249-4.40682489-11.4511327-4.71392298-16.22474267-.70732109-4.77361001 4.00660193-5.6925741 10.99745923-2.1165963 16.10163343z",
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.686667 13.306667-5.38 5.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.306667 13.306667 5.38 5.38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineCircle);
export default __webpack_public_path__ + "static/media/decline-circle.67fb9fb19a078d229c8f7b99e5521c91.svg";
export { ForwardRef as ReactComponent };